import { Table, Tag, Dropdown, Typography } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import TaskMenu from '../../Molecules/DropDownMenu/DropDownMenu';
import { ReactComponent as More } from '../../../res/svg/more.svg';
import Task from '../../../models/Task';
import { taskStateItems, truncateStringEllipsis} from '../../../utils/functions';
import './TaskTable.less';
import AvatarStateUser from '../../Molecules/AvatarStateUser/AvatarStateUser';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { setTaskFilters } from '../../../store/slice/taskSlice';
/**
 * @component TaskTable.tsx
 * @description TaskTable component to show the task list.
 * @return { Component }
 */
interface TaskTableProps {
  data: Task[];
  deleteTaskModal? : (taskId: number) => void;
  actionCloneTask? : (taskId: number) => void;
  actionExportTask? : (taskId: number, titulo: string) => void;
}

function TaskTable(props: TaskTableProps) {

  const { Text } = Typography;
  const dispatch = useAppDispatch();
  const filtros = useAppSelector(state => state.task.filtros);
  const totalItems = useAppSelector(state => state.task.totalItems);

  const deleteTask = (taskId: number) => {
    if(props.deleteTaskModal){
      props.deleteTaskModal(taskId);
    }
  }

  const cloneTask = (taskId: number) => {
    if(props.actionCloneTask){
      props.actionCloneTask(taskId);
    }
  }

  const sorter: any = (a: any, b: any) =>
    isNaN(a) && isNaN(b) ? (a || '').localeCompare(b || '') : a - b;


  const columns: ColumnsType<any> = [
    {
      title: 'Nombre de Tarea',
      dataIndex: 'titulo',
      render: (_id, row) => <Text className="title-task" title={row.titulo}>{truncateStringEllipsis(row.titulo, 32)}</Text>,
      sortDirections: ['descend', 'ascend'],
      sorter: (a: Task, b: Task) => sorter(a.titulo, b.titulo),
      width: 200
    },
    {
      title: 'Creada',
      dataIndex: 'creada',
      render: (_id, row) => <>{moment(row.createdAt).format('DD/MM/YYYY')}</>,
      sorter: (a: Task, b: Task) => sorter(a.createdAt, b.createdAt),
      width: 110
    },
    {
      title: 'Tipo de tarea',
      dataIndex: 'tipoTarea',
      render: (_id, row) => (
        <Tag title={row.tipotarea.tipotarea} style={{color: `#${row?.tipotarea?.color}`, borderColor: `#${row?.tipotarea?.color}`, marginRight: '0px'}}>{truncateStringEllipsis(row.tipotarea.tipotarea, 23)}</Tag>
      ),
      sorter: (a: Task, b: Task) => sorter(a.tipotarea?.tipotarea, b.tipotarea?.tipotarea),
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      align: 'left',
      render: (_id, row) => (
        <Tag className={taskStateItems(row.estado).className} style={{marginRight: '0px'}}>
          {taskStateItems(row.estado).title}
        </Tag>
      ),
      sorter: (a: Task, b: Task) => sorter(taskStateItems(a.estado!).title, taskStateItems(b.estado!).title),
      responsive: ['md'],
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      render: (_id, row) => <Text title={row.descripcion}>{truncateStringEllipsis(row.descripcion, 42)}</Text>,
      width: 180
    },
    {
      title: 'Observaciones',
      dataIndex: 'observaciones',
      render: (_id, row) => <Text title={row.observaciones}>{truncateStringEllipsis(row.observaciones, 42)}</Text>,
      responsive: ['xl'],
      width: 180
    },
    {
      title: 'Asignado(s)',
      dataIndex: 'asignado',
      align: 'left',
      render: (_id, task) => (
        <>
          {
            task.tareaUsuario[0] ?
            <>
              {task.tareaUsuario![0] !== undefined && (
                <div className={'assign_users'}>
                  <AvatarStateUser arrayUsers = {task.tareaUsuario}/>
                </div>
              )}
            </> : <>-</>
          }
        </>
      ),
      responsive: ['xl'],
    },
    {
      title: 'Realización',
      render: (row) => (
        <>
          {row.fechaDesde ?
            <>
              {moment(row.fechaDesde).format('DD/MM/YYYY')} <br></br> {moment(row.fechaHasta).format('DD/MM/YYYY')}
            </> : <>-</>}
        </>
      ),
      width: 105,
      responsive: ['lg'],
    },
    {
      title: 'Acciones',
      responsive: ['lg'],
      align: 'center',
      render: (task) => (
        <Dropdown overlay={
          <TaskMenu
            task={task}
            deleteTaskModal={deleteTask}
            actionCloneTask={cloneTask}
            actionExportTask={props.actionExportTask}
          />
        } placement="bottomLeft">
          <More className="icon-more"/>
        </Dropdown>
      ),
      width: 94
    },
  ];

  return (
    <Table
          columns={columns}
          dataSource={props.data}
          rowKey={(task) => task.id}
          sortDirections={['descend', 'ascend']}
          locale={{ emptyText: 'No hay tareas para mostrar.' }}
          pagination={{
            defaultPageSize:filtros.pageSize,
            locale: { items_per_page: '/ página' },
            className: 'org-user-table__pagination',
            current: Math.max(filtros.page, 1),
            total: totalItems,
            pageSize: filtros.pageSize,
            onChange: (page, pageSize) => {
              dispatch(setTaskFilters({ page, pageSize }));
            },
          }}
        />
  );
}

export default TaskTable;
